// Plan madde 8.2 — sonner Toaster mount.
//
// Renders a single global Toaster that listens for toast.* calls from
// anywhere in the app. Sonner mounts a portal into <body>, so the
// position in the React tree only matters for context inheritance
// (i18n + theme); the visual position is configured via props.
//
// Composes inside the i18n + ErrorBoundary layers so toast titles/
// descriptions can resolve through useTranslation, and so a toast
// fired from inside a render error still has the i18n bundle available
// (the error boundary renders its own UI but doesn't unmount the
// providers above it). Outside the Router so toasts persist across
// navigation — a 401 fired right before the user navigates away still
// stays visible on the next route.

import { Toaster } from "sonner";

export function ToastProvider(): React.ReactElement {
  return (
    <Toaster
      // Top-right matches operator console mental model — the impersonation
      // banner (plan madde 11.1) lands at top, sudo timer at top-right too;
      // toasts share that visual zone so the operator's eye is already
      // there when a notification fires.
      position="top-right"
      // 5s default — enough to read a multi-line description, short
      // enough that stale toasts don't clutter the surface.
      duration={5000}
      // Rich colors for sonner's variant icons (red error, amber warning,
      // blue info) — matches the spec 44 design tokens semantic palette.
      // Unaffected by the operator brand colour (SEM-6367): --brand-operator
      // recolours the identity mark, not the status vocabulary.
      richColors
      // closeButton lets operators dismiss noisy toasts manually
      // (plan madde 11 will add a "Stay signed in" action on idle-warning
      // toasts that needs the close affordance to stay visible).
      closeButton
    />
  );
}
